/**
 * PageMeta — Sets a semantic H1 + document.title for SEO on dedicated pages.
 *
 * The H1 is rendered as `sr-only` so it doesn't compete visually with the
 * component's existing H2 (which acts as the main visual heading), but search
 * engines and screen readers see a proper page title structure.
 */
import { useEffect } from "react";

const PageMeta = ({ title, h1, description }) => {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            let meta = document.querySelector('meta[name="description"]');
            if (!meta) {
                meta = document.createElement("meta");
                meta.setAttribute("name", "description");
                document.head.appendChild(meta);
            }
            meta.setAttribute("content", description);
        }
    }, [title, description]);

    return (
        <h1 className="sr-only" data-testid="page-h1">
            {h1 || title}
        </h1>
    );
};

export default PageMeta;
